module.exports = __webpack_public_path__ + "img/StoreItems.6938f3fc.svg";